import { Omit } from 'bold-ui'
import { SelectField, SelectFieldProps } from 'components/form/final-form'
import { BairroSelectFieldDocument } from 'graphql/hooks.generated'
import { BairroSelectFieldQuery, BairroSelectFieldQueryVariables } from 'graphql/types.generated'
import React from 'react'

import { DEFAULT_SELECT_SIZE } from '../AsyncQuerySelectField'
import { useAsyncQuerySelect } from '../useAsyncQuerySelect'

export type BairroSelectFieldModel = Partial<BairroSelectFieldQuery['bairros']['content'][0]>

export interface BairrosSelectFieldProps
  extends Omit<SelectFieldProps<BairroSelectFieldModel>, 'items' | 'itemToString'> {
  municipioId?: ID
  ufId?: ID
}

export function BairroSelectField(props: BairrosSelectFieldProps) {
  const { ufId, municipioId, ...rest } = props

  const { loading, ...asyncProps } = useAsyncQuerySelect<
    BairroSelectFieldModel,
    BairroSelectFieldQuery,
    BairroSelectFieldQueryVariables
  >({
    query: BairroSelectFieldDocument,
    extractItems: data => data && data.bairros && data.bairros.content,
    variables: (inputQuery: string) => ({
      input: {
        ufId,
        municipioId,
        query: inputQuery,
        pageParams: {
          size: DEFAULT_SELECT_SIZE,
          sort: ['nome'],
        },
      },
    }),
  })

  const itemToString = (item: BairroSelectFieldModel) => item && item.nome
  const createNewItem = (text: string) => ({ nome: text })

  return (
    <SelectField<BairroSelectFieldModel>
      itemToString={itemToString}
      createNewItem={createNewItem}
      icon={null}
      {...asyncProps}
      {...rest}
    />
  )
}
